export default {
    meta: {
        title: '拓店任务详情',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务'
    }
};
